// extracted by mini-css-extract-plugin
export default {"back-btn":"back-button_back-btn__Tmb1I"};